export const DataSourceDetailConstants = {
    SET_USER_CONTEXT: 'dataSourceDetail/schema/SET_USER_CONTEXT',
    SET_PARTIAL_USER_CONTEXT: 'dataSourceDetail/schema/SET_PARTIAL_USER_CONTEXT',
};
export const getDefaultState = () => {
    return {
        userContext: {
            schemaFilter: null,
        },
    };
};
const setPartialUserContext = (state, actionResult) => {
    return {
        ...state,
        userContext: {
            ...state.userContext,
            ...actionResult.payload,
        },
    };
};
export function setPartialUserContextFunc(userContext) {
    return {
        type: DataSourceDetailConstants.SET_PARTIAL_USER_CONTEXT,
        payload: userContext,
    };
}
export const setUserContext = (state, actionResult) => {
    return {
        ...state,
        userContext: actionResult.payload,
    };
};
export function setUserContextFunc(userContext) {
    return {
        type: DataSourceDetailConstants.SET_USER_CONTEXT,
        payload: userContext,
    };
}
export const DataSourceDetailReducer = (state = getDefaultState(), actionResult) => {
    switch (actionResult.type) {
        case DataSourceDetailConstants.SET_USER_CONTEXT:
            return setUserContext(state, actionResult);
        case DataSourceDetailConstants.SET_PARTIAL_USER_CONTEXT:
            return setPartialUserContext(state, actionResult);
        default:
            return state;
    }
};
export default DataSourceDetailReducer;

//# sourceMappingURL=DataSourceDetailContext.ducks.js.map
